<template>
  <div v-if="!this.store.isConflict">
      <div style="display: flex;
      justify-content: center;
      gap: 35px;" >
        <div>
          <div class="top-btn" title="Save changes to DB"  aria-controls="exampleModal"  >
            <icon-svg class="icon-menu" :height="25" :width="25" style="margin-inline: 8px" icon="prime:save"
              @click="syncChangesToDB()" />
            <span >Save</span>
          </div>
          <span v-if="showErrorMessage == true">Saving Error!</span>
          <span v-if="showSuccsesMessage == true">Saving Succsesfuly!</span>
        </div>
        <div>
          <div class="top-btn" title="Reset Store" @click="exampleModal = true" aria-controls="exampleModal">
            <icon-svg class="icon-menu" :height="25" :width="25" style="margin-inline: 8px" icon="prime:save" />
            <span> Reset</span>
          </div>
        </div>
        <div> 
          <div class="top-btn" title="Reset Store" @click="exampleHardModal = true" aria-controls="exampleHardModal">
            <icon-svg class="icon-menu" :height="25" :width="25" style="margin-inline: 8px" icon="prime:save" />
            <span> Fix Products Store</span>
          </div>
        </div>
        <div>
          <div class="top-btn" title="Reset Store" @click="exampleFoneModal = true" aria-controls="exampleFoneModal">
            <icon-svg class="icon-menu" :height="25" :width="25" style="margin-inline: 8px" icon="prime:save" />
            <span>fix Font Store</span>
          </div>
        </div>
        <MDBModal size="sm" id="exampleModal" tabindex="-1" labelledby="exampleModalLabel" v-model="exampleModal">
          <MDBModalHeader>
            <MDBModalTitle id="exampleModalLabel"> Modal title </MDBModalTitle>
          </MDBModalHeader>
          <MDBModalBody>
            Resetting the data will delete everything that is currently there
            <br />
            and re-import the material from the database,
            <br />
            It is possible that changes you made recently will not be saved.
            <br />
            Are you sure you want to clear all data?
          </MDBModalBody>
          <MDBModalFooter>
            <MDBBtn color="secondary" @click="exampleModal = false">Cancle</MDBBtn>
            <MDBBtn color="primary" @click="resetStore()">Reset Store</MDBBtn>
          </MDBModalFooter>
        </MDBModal>
  
        <MDBModal size="sm" id="exampleHardModal" tabindex="-1" labelledby="exampleHardModalLabel"
          v-model="exampleHardModal">
          <MDBModalHeader>
            <MDBModalTitle id="exampleHardModalLabel"> Modal title </MDBModalTitle>
          </MDBModalHeader>
          <MDBModalBody>
            Resetting the data will delete everything that is currently there
            <br />
            and re-import the material from the database,
            <br />
            It is possible that changes you made recently will not be saved.
            <br />
            Are you sure you want to clear all data?
          </MDBModalBody>
          <MDBModalFooter>
            <MDBBtn color="secondary" @click="exampleHardModal = false">Cancle</MDBBtn>
            <MDBBtn color="primary" @click="checkProductStore()">Fix Products Store</MDBBtn>
          </MDBModalFooter>
        </MDBModal>
        <MDBModal size="sm" id="exampleFoneModal" tabindex="-1" labelledby="exampleFoneModalLabel"
          v-model="exampleFoneModal">
          <MDBModalHeader>
            <MDBModalTitle id="exampleFoneModalLabel"> Modal title </MDBModalTitle>
          </MDBModalHeader>
          <MDBModalBody>
            Clicking on fixFontStore will delete from your memory all the problematic fonts,
            <br />
            most likely the ones that were recently uploaded,
            <br />
            then you will have to save the changes so that it doesn't happen to you again
          </MDBModalBody>
          <MDBModalFooter>
            <MDBBtn color="secondary" @click="exampleFoneModal = false">Cancle</MDBBtn>
            <MDBBtn color="primary" @click="fixFontStore()">fix Font Store</MDBBtn>
          </MDBModalFooter>
        </MDBModal>
        <span v-if="showErrorMessage == true">Saving Error!</span>
        <span v-if="showSuccsesMessage == true">Saving Succsesfuly!</span>
      </div>
      <MDBTabs v-model="controlName">
        <MDBTabNav tabsClasses="mb-3">
          <MDBTabItem tabId="ColorEditor" href="ColorEditor">Color editor</MDBTabItem>
          <MDBTabItem tabId="ArtEditor" href="ArtEditor">Art editor</MDBTabItem>
          <MDBTabItem tabId="MonogramEditor" href="MonogramEditor">Monogram editor</MDBTabItem>
          <MDBTabItem tabId="MaterialEditor" href="MaterialEditor">Material editor</MDBTabItem>
          <MDBTabItem tabId="FontEditor" href="FontEditor">Font editor</MDBTabItem>
          <MDBTabItem tabId="ProductEditor" href="ProductEditor">Product editor</MDBTabItem>
          <MDBTabItem tabId="DstToUserArts" href="DstToUserArts">Add Dst to user's images</MDBTabItem>
        </MDBTabNav>
  
        <MDBTabContent>
          <MDBTabPane tabId="ColorEditor">
            <ColorEditor />
          </MDBTabPane>
          <MDBTabPane tabId="ArtEditor">
            <ArtEditor />
          </MDBTabPane>
          <MDBTabPane tabId="MonogramEditor">
            <MonogramEditor />
          </MDBTabPane>
          <MDBTabPane tabId="MaterialEditor">
            <MaterialEditor />
          </MDBTabPane>
          <MDBTabPane tabId="FontEditor">
            <FontEditor />
          </MDBTabPane>
          <MDBTabPane tabId="ProductEditor">
            <ProductEditor />
          </MDBTabPane>
          <MDBTabPane tabId="DstToUserArts">
            <DstToUserArts />
          </MDBTabPane>
        </MDBTabContent>
      </MDBTabs>
    </div>
  
    <div v-if="this.store.isConflict" style="display: flex; justify-content: center; align-items: center; height: 100vh;">
  <MDBCard style="width: 27rem; padding: 20px;">
     <h4>You have conflict between data to localStorage you have to choose</h4>
    <MDBListGroup border:true style="border:1px solid red;" flush v-for="(item, index) in this.store.conflictArray" :key="index">
      <MDBListGroupItem style="display: flex; justify-content: space-between; align-items: center;">
        {{item.key}}
        <div>
          <MDBRadio 
            label="data" 
            value="data" 
            v-model="item.preference" 
            inline 
            :name="`preference-${index}`" 
            :key="`data-${index}`" 
          />
          <MDBRadio 
            label="server" 
            value="server" 
            v-model="item.preference" 
            inline 
            :name="`preference-${index}`" 
            :key="`server-${index}`" 
          />
        </div>
      </MDBListGroupItem>
    </MDBListGroup>
    <MDBCardFooter style="text-align: center;">
      <v-btn text="submit" @click="submitSelectServerOrDate"></v-btn>
    </MDBCardFooter>
  </MDBCard> 
</div>
  
  </template>
  
  <script>
  import { designerStore } from "@/stores/designerStore";
  import DstToUserArts from "./DstToUserArts.vue";
  import ColorEditor from "./ColorEditor.vue";
  import ArtEditor from "./ArtEditor.vue";
  import MonogramEditor from "./MonogramEditor.vue";
  import MaterialEditor from "./MaterialEditor.vue";
  import FontEditor from "./FontEditor.vue";
  import ProductEditor from "./ProductEditor.vue";
  import { ref } from 'vue';
  import {
    MDBTabs,
    MDBTabNav,
    MDBTabContent,
    MDBTabItem,
    MDBTabPane,
    MDBModal,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody,
    MDBModalFooter,
    MDBBtn,
    MDBCard, MDBCardFooter, MDBListGroup, MDBListGroupItem,MDBRadio 
  } from "mdb-vue-ui-kit";
  export default {
  
    setup() {
      const store = designerStore();
      const controlName = ref("ColorEditor");
      const exampleModal = ref(false);
      const exampleHardModal = ref(false);
      const exampleFoneModal  = ref(false);
  
  
      return {
        store,
        controlName,
        exampleModal,
        exampleHardModal,
        exampleFoneModal
      };
    },

    
    components: {
      DstToUserArts,
      ColorEditor,
      ArtEditor,
      MonogramEditor,
      MaterialEditor,
      FontEditor,
      ProductEditor,
      MDBTabs,
      MDBTabNav,
      MDBTabContent,
      MDBTabItem,
      MDBTabPane,
      MDBModal,
      MDBModalHeader,
      MDBModalTitle,
      MDBModalBody,
      MDBModalFooter,
      MDBBtn,
      MDBCard, 
      MDBCardFooter, 
      MDBListGroup,  
      MDBListGroupItem ,MDBRadio 
    },
    data() {
      return {  
        // controlName: null,
        showErrorMessage:  false,
        showSuccsesMessage: false,        
      };
    },
  
    methods: {
      submitSelectServerOrDate(){
        this.store.conflictArray.forEach(item=>{
         console.log(this.store[item.key]);
       if(item.preference=="data"){
          this.store[item.key]== JSON.parse(localStorage.getItem(item.key)).value ;
          console.log(this.store[item.key]);
       }
       })
       this.store.isConflict=!this.store.isConflict;    
      },  
   
      async resetStore() {
        console.log('enter ResetStore');
        await this.store.resetStore(); //['allColors', 'allArts', 'allFonts', 'allMonograms', 'allMaterials', 'allArtCategories']); //, 'allProducts'
        this.exampleModal = false;
      },
      async checkProductStore() {
        console.log('enter checkProductStore');
        //שולח לשחזר מהדאטה לא כולל המוצרים כדי שאותם ייבא שוב מהשופיפי
        this.store.checkProductStore();
        this.exampleHardModal = false;
      },
      fixFontStore() {
        console.log('enter checkProductStore');
        //שולח לשחזר מהדאטה לא כולל המוצרים כדי שאותם ייבא שוב מהשופיפי
        this.store.fixFontStore();
        this.exampleFoneModal = false;
      },
      async syncChangesToDB()  {
        try {
          await this.store.saveAdminChanges();
        } catch (error) {
          this.showErrorMessage = true;
          this.showSuccsesMessage = false;
            setTimeout(() => {
            this.showErrorMessage = false;
          }, 5000);
        }
        this.showSuccsesMessage = true;
        this.showErrorMessage = false;
        setTimeout(() => {
          this.showSuccsesMessage = false;
        }, 5000);
      }
      ,
    }
  };
  
  
  
  </script>
  
  <style>
  .nav-tabs {
    justify-content: center;
  }
  
  .row.mt-2 {
    justify-content: center;
  }
  
  .top-btn {
    display: grid;
    justify-items: center;
  }
  
  .modal-dialog.modal-sm {
    
    max-width: 500px !important;
    height: auto !important;
  }
  
  </style> 